// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2lPTL","icon":"SortAdornment_icon__1L2yW","up":"SortAdornment_up__14D9o","down":"SortAdornment_down__mPZH1","active":"SortAdornment_active___gLYR"};